import { Box, Stack, Typography } from "@mui/material";
import { ConversationMessage, timeSimplifier } from "../../../redux/conversation/conversationSlice";
import { MessageContent } from "./MessageContent";

export interface MessageTileMyselfProps {
    message: ConversationMessage;
    content?: React.ReactNode;
}

export const MessageTileMyself = (props: MessageTileMyselfProps) => {
    const msg = props.message;
    // const image = "abc";
    // const name = msg.partyId;
    const dt = timeSimplifier( msg.processed );
    
    const message = <MessageContent message={msg} content={props.content} align="right"/>;

    return <Box sx={{ marginLeft: 16, marginY: 1 }}>
        <Stack direction="row" spacing={1}>
            <Box sx={{flexGrow: 1}} />
            <Box key={dt}
                sx={{ padding: 1, borderRadius: 2, border: "1px black solid", backgroundColor: "#ccFFCC", minWidth: 300 }}>
                <Stack direction="column" spacing={0}>
                    <Typography variant="body2" component="span" color='black' textAlign={"right"} sx={{overflowWrap: "anywhere"}}>
                        {message}
                    </Typography>
                    <Typography variant="caption" component="span" fontSize={9} sx={{ textAlign: "right", color: "#555", marginY: "-2px" }}>
                        {dt}
                    </Typography>
                </Stack>
            </Box>
        </Stack>
    </Box>;
};

